import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';
import type { GetRedditAdAccountsAction } from './getAdAccounts.action';
import type { GetRedditAuthenticationUrlAction } from './getAuthenticationUrl.action';

export * from './getAdAccounts.action';
export * from './getAuthenticationUrl.action';

export type RedditAction = GetRedditAdAccountsAction | GetRedditAuthenticationUrlAction | GetSanAdAccountZeitStatusAction;
